import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpInputComponent from './adpInput.component';

let adpInputModule = angular.module('adpInput', [
  uiRouter
])

.component('adpInput', adpInputComponent)

.name;

export default adpInputModule;



// WEBPACK FOOTER //
// ./src/app/components/adpInput/adpInput.js